import { $Divider } from './Divider.styles';
import { DENSITY, Density } from './Divider.types';

interface DividerProps {
  density?: Density;
}

export const Divider = ({ density = DENSITY.COMPACT }: DividerProps) => {
  return <$Divider data-density={density} />;
};

Divider.displayName = 'Divider';
